

import { interpolateSafe, PhraseMap } from '@ms/yammer-i18n';

export default class InterpolateStrings {

  public static feature: string = 'common';

  private locale: string;
  private phrases: PhraseMap;

  constructor(locale: string, phrases: PhraseMap) {
    this.locale = locale;
    this.phrases = phrases;
  }

  public commonOK(): string {
    return interpolateSafe(this.locale, this.phrases, 'commonOK');
  }

  public commonGotIt(): string {
    return interpolateSafe(this.locale, this.phrases, 'commonGotIt');
  }

  public commonContinue(): string {
    return interpolateSafe(this.locale, this.phrases, 'commonContinue');
  }

  public commonCancel(): string {
    return interpolateSafe(this.locale, this.phrases, 'commonCancel');
  }

  public commonSubmit(): string {
    return interpolateSafe(this.locale, this.phrases, 'commonSubmit');
  }

  public commonSave(): string {
    return interpolateSafe(this.locale, this.phrases, 'commonSave');
  }

  public commonClose(): string {
    return interpolateSafe(this.locale, this.phrases, 'commonClose');
  }

  public commonDismiss(): string {
    return interpolateSafe(this.locale, this.phrases, 'commonDismiss');
  }

  public commonDownload(): string {
    return interpolateSafe(this.locale, this.phrases, 'commonDownload');
  }

  public commonDownloadFile(args: { file: string|number }): string {
    return interpolateSafe(this.locale, this.phrases, 'commonDownloadFile', args);
  }

  public commonLearnMore(): string {
    return interpolateSafe(this.locale, this.phrases, 'commonLearnMore');
  }

  public commonSomethingWentWrongRetry(): string {
    return interpolateSafe(this.locale, this.phrases, 'commonSomethingWentWrongRetry');
  }

  public commonLoading(): string {
    return interpolateSafe(this.locale, this.phrases, 'commonLoading');
  }

  public commonReload(): string {
    return interpolateSafe(this.locale, this.phrases, 'commonReload');
  }

  public commonRetry(): string {
    return interpolateSafe(this.locale, this.phrases, 'commonRetry');
  }

  public commonCopy(): string {
    return interpolateSafe(this.locale, this.phrases, 'commonCopy');
  }

  public commonYes(): string {
    return interpolateSafe(this.locale, this.phrases, 'commonYes');
  }

  public commonNo(): string {
    return interpolateSafe(this.locale, this.phrases, 'commonNo');
  }

  public commonSkip(): string {
    return interpolateSafe(this.locale, this.phrases, 'commonSkip');
  }

  public commonOptionSelectedItemQualifier(): string {
    return interpolateSafe(this.locale, this.phrases, 'commonOptionSelectedItemQualifier');
  }

  public commonApply(): string {
    return interpolateSafe(this.locale, this.phrases, 'commonApply');
  }

  public commonFictiousUserFemale(): string {
    return interpolateSafe(this.locale, this.phrases, 'commonFictiousUserFemale');
  }

  public commonOpensInNewTab(): string {
    return interpolateSafe(this.locale, this.phrases, 'commonOpensInNewTab');
  }

  public commonWait(): string {
    return interpolateSafe(this.locale, this.phrases, 'commonWait');
  }

  public commonPrevious(): string {
    return interpolateSafe(this.locale, this.phrases, 'commonPrevious');
  }

  public commonNext(): string {
    return interpolateSafe(this.locale, this.phrases, 'commonNext');
  }

  public commonCurrentStepOfTotal(args: { current: string|number; total: string|number }): string {
    return interpolateSafe(this.locale, this.phrases, 'commonCurrentStepOfTotal', args);
  }

  public commonNotNow(): string {
    return interpolateSafe(this.locale, this.phrases, 'commonNotNow');
  }

  public commonConfirm(): string {
    return interpolateSafe(this.locale, this.phrases, 'commonConfirm');
  }

  public commonInfo(): string {
    return interpolateSafe(this.locale, this.phrases, 'commonInfo');
  }

  public commonTip(): string {
    return interpolateSafe(this.locale, this.phrases, 'commonTip');
  }

  public commonMoreItems(): string {
    return interpolateSafe(this.locale, this.phrases, 'commonMoreItems');
  }

  public commonWarning(): string {
    return interpolateSafe(this.locale, this.phrases, 'commonWarning');
  }

  public commonThousandsSuffix(args: { number: string|number }): string {
    return interpolateSafe(this.locale, this.phrases, 'commonThousandsSuffix', args);
  }

  public commonAdditionalCountPrefix(args: { number: string|number }): string {
    return interpolateSafe(this.locale, this.phrases, 'commonAdditionalCountPrefix', args);
  }

}
